// 보강서류 시트 — 대행요청 1건(차량 1대)의 보강서류 이력을 요청 맥락 안에서 처리한다.
//
// 구 '보강서류' 독립 세그먼트를 흡수한 화면 (A안, 2026-08-26). 앱 정합 —
// erp/app/lib/features/cancel_doc/widgets/cancel_doc_section.dart 가 말소요청 상세의
// 한 섹션으로 carId 기준 목록을 보여주는 것과 같은 구성. 웹은 대행사 측 액션(완료/취소/
// 메시지/신규 발행)이 더 있어 시트로 띄운다.
//
// 구 탭에서 그대로 옮겨온 것: 상태 배지 · 요청 서류/메모 · 제출 첨부 다운로드 · 요청일 ·
//   메시지 스레드(열기/전송) · 요청 취소 · 완료 처리 · 목록 새로고침.
// 발행 모달(docReqModal)은 CancelAgency.js 에 그대로 두고 onNew 로 띄운다(자동추천 포함).
//
// 메시지 스레드 상태는 이 파일이 가진다 — 구 탭의 docMsgOpenId/docMsgs/docMsgText 이관.
import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';

// 행 배지 요약 (순수) — 대행요청 표의 배지가 읽는 값.
//   '취소'된 요청은 세지 않는다(앱 cancel_doc_section.dart 의 status != '취소' 필터 정합).
//   미확인(제출됨) 우선 — 대행사가 지금 해야 할 일이 '확인'이라서.
export function docReqSummary(list, carId) {
  var cid = parseInt(carId, 10);
  var pending = 0, submitted = 0, done = 0;
  (list || []).forEach(function (r) {
    if (!r || parseInt(r.carId, 10) !== cid) return;
    if (r.status === '취소') return;
    if (r.status === '제출') submitted++;
    else if (r.status === '완료') done++;
    else pending++;
  });
  var total = pending + submitted + done;
  if (total === 0) return { total: 0, pending: 0, submitted: 0, done: 0, label: '서류 +', tone: 'none', title: '보강서류 — 요청 없음 (클릭해 발행)' };
  if (submitted > 0) return { total: total, pending: pending, submitted: submitted, done: done, label: '서류 제출됨 ' + submitted, tone: 'blue', title: '제출된 보강서류 ' + submitted + '건 — 확인 필요' };
  if (pending > 0) return { total: total, pending: pending, submitted: submitted, done: done, label: '서류 요청 ' + pending, tone: 'gray', title: '보강서류 요청 ' + pending + '건 — 제출 대기' };
  return { total: total, pending: pending, submitted: submitted, done: done, label: '서류 완료 ' + done, tone: 'done', title: '보강서류 ' + done + '건 완료' };
}

// 상태 배지 색 — 구 탭 dsc 그대로.
function statusStyle(s) {
  if (s === '완료') return { bg: '#f0fdf4', c: '#15803d' };
  if (s === '제출') return { bg: '#eff6ff', c: '#1d4ed8' };
  if (s === '취소') return { bg: '#f1f5f9', c: '#64748b' };
  return { bg: '#fef2f2', c: '#b91c1c' };
}

// items = 이 차량의 보강서류 요청 배열(취소 포함 — 이력이라 감추지 않는다).
function CancelAgencyDocReqSheet(props) {
  var items = props.items || [];
  var isMobile = !!props.isMobile;
  var showToast = props.showToast || function () {};
  var tapBtn = isMobile ? { minHeight: 40 } : undefined;

  var [msgOpenId, setMsgOpenId] = useState(0);
  var [msgs, setMsgs] = useState([]);
  var [msgText, setMsgText] = useState('');

  var openMsg = function (it) {
    if (msgOpenId === it.id) { setMsgOpenId(0); setMsgs([]); return; }
    setMsgOpenId(it.id); setMsgs([]); setMsgText('');
    authFetch(API + '/cancel-doc-requests/' + it.id + '/messages').then(function (r) { return r.json(); })
      .then(function (d) { setMsgs(Array.isArray(d) ? d : []); }).catch(function () {});
  };
  var sendMsg = function (it) {
    var body = (msgText || '').trim(); if (!body) return;
    authFetch(API + '/cancel-doc-requests/' + it.id + '/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: body }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (d.success) {
          setMsgText('');
          authFetch(API + '/cancel-doc-requests/' + it.id + '/messages').then(function (r) { return r.json(); }).then(function (m) { setMsgs(Array.isArray(m) ? m : []); });
        } else showToast(d.error || '전송 실패', 'err');
      }).catch(function () { showToast('전송 실패', 'err'); });
  };

  // 모바일 = 바텀시트 / 데스크탑 = 중앙 모달 (모달 반응형 정책).
  var panel = isMobile
    ? { width: '100%', maxHeight: '88vh', borderRadius: '14px 14px 0 0' }
    : { width: 620, maxWidth: '94vw', maxHeight: '86vh', borderRadius: 12 };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center', zIndex: 9990 }} onClick={props.onClose}>
      <div style={Object.assign({ background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden', fontFamily: 'Pretendard,-apple-system,BlinkMacSystemFont,sans-serif' }, panel)} onClick={function (e) { e.stopPropagation(); }}>
        {/* 헤더 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: isMobile ? '14px 16px' : '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: '#1e3a5f' }}>보강서류</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{props.carNo || '-'} — 부족 서류를 수출업체에 요청하고 제출을 확인합니다.</div>
          </div>
          <button className="btn btn-outline btn-sm" title="새로고침" style={tapBtn} onClick={props.onRefresh}>새로고침</button>
          <button className="btn btn-outline btn-sm" title="닫기" style={tapBtn} onClick={props.onClose}>✕</button>
        </div>

        {/* 목록 */}
        <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? 12 : 16, background: '#f8fafc' }}>
          {/* 동시 작업 배너 — 이 시트도 대행요청 1건(reqId)에 프레즌스 enter 하는 편집 화면이다
              (완료/취소/메시지 전송). 부모(CancelAgency.js)의 presenceBanner 를 그대로 받는다. */}
          {props.presenceBanner}
          {items.length === 0 && (
            <div style={{ padding: '36px 12px', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
              이 차량의 보강서류 요청이 없습니다.<br />아래 [새 보강서류 요청] 으로 발행하세요.
            </div>
          )}
          {items.map(function (it) {
            var ss = statusStyle(it.status);
            var files = it.files || [];
            return (
              <div key={it.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: 12, marginBottom: 10, opacity: it.status === '취소' ? 0.6 : 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <span style={{ padding: '4px 8px', borderRadius: 12, fontSize: 11, fontWeight: 'bold', background: ss.bg, color: ss.c }}>{it.status}</span>
                  <span style={{ fontSize: 12, color: '#94a3b8' }}>{it.requestedAt || '-'}</span>
                  <span style={{ flex: 1 }} />
                  {!!it.companyName && <span style={{ fontSize: 12, color: '#64748b' }}>{it.companyName}</span>}
                </div>
                <div style={{ fontSize: 12.5, color: '#475569' }}>
                  {(it.requestedDocs || []).join(', ') || <span style={{ color: '#94a3b8' }}>메모</span>}
                  {it.memo && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{it.memo}</div>}
                </div>
                <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', marginRight: 2 }}>제출 첨부</span>
                  {files.length > 0 ? files.map(function (f) {
                    return (<button key={f.id} className="btn btn-outline btn-sm" title={f.originalName} onClick={function () { props.onOpenFile(it.id, f.id); }} style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.originalName}</button>);
                  }) : <span style={{ color: '#94a3b8', fontSize: 12 }}>미제출</span>}
                </div>
                <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  <button className="btn btn-outline btn-sm" style={tapBtn} onClick={function () { openMsg(it); }}>{'메시지' + (it.messageCount ? ' ' + it.messageCount : '')}</button>
                  <span style={{ flex: 1 }} />
                  {it.status === '요청' && <button className="btn btn-outline btn-sm btn-danger" style={tapBtn} onClick={function () { props.onCancelReq(it.id); }}>요청 취소</button>}
                  {it.status !== '완료' && it.status !== '취소' && <button className="btn btn-blue btn-sm" style={tapBtn} onClick={function () { props.onComplete(it.id); }}>완료</button>}
                </div>
                {msgOpenId === it.id && (
                  <div style={{ marginTop: 10, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: 10 }}>
                    <div style={{ maxHeight: 180, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
                      {msgs.length === 0 && <div style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', padding: 6 }}>메시지가 없습니다</div>}
                      {msgs.map(function (m) {
                        var mine = m.sender === 'agency';
                        return (<div key={m.id} style={{ alignSelf: mine ? 'flex-end' : 'flex-start', maxWidth: '70%', background: mine ? '#1B3A5C' : '#e2e8f0', color: mine ? '#fff' : '#1e293b', borderRadius: 10, padding: '6px 10px', fontSize: 13 }}>{m.body}<div style={{ fontSize: 9, opacity: 0.7, marginTop: 2 }}>{(mine ? '나' : '수출업체') + ' · ' + (m.createdAt || '')}</div></div>);
                      })}
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input value={msgText} onChange={function (e) { setMsgText(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') sendMsg(it); }} placeholder="메시지 입력..." aria-label="메시지 입력" style={{ flex: 1, minWidth: 0, padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 8, fontSize: 13, outline: 'none', minHeight: isMobile ? 40 : undefined }} />
                      <button className="btn btn-blue btn-sm" style={tapBtn} onClick={function () { sendMsg(it); }}>전송</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* 발행 — 요청이 없어도 여기서 시작한다(구 탭의 발행 동선 대체) */}
        <div style={{ padding: isMobile ? 12 : 16, borderTop: '1px solid #e2e8f0' }}>
          <button className="btn btn-blue" style={Object.assign({ width: '100%' }, tapBtn)} onClick={props.onNew}>새 보강서류 요청</button>
        </div>
      </div>
    </div>
  );
}

export default CancelAgencyDocReqSheet;
